var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#464646",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.923 17V7.9H9.355C10.2997 7.9 11.0147 8.121 11.5 8.563C11.9853 9.005 12.228 9.55967 12.228 10.227C12.228 10.8077 12.072 11.2713 11.76 11.618C11.448 11.956 11.071 12.1857 10.629 12.307C10.9757 12.3763 11.2833 12.515 11.552 12.723C11.8293 12.931 12.046 13.191 12.202 13.503C12.358 13.815 12.436 14.153 12.436 14.517C12.436 14.985 12.319 15.4097 12.085 15.791C11.8597 16.1637 11.526 16.4583 11.084 16.675C10.642 16.8917 10.1003 17 9.459 17H5.923ZM7.301 11.8H9.186C9.71467 11.8 10.1177 11.6787 10.395 11.436C10.6723 11.1847 10.811 10.8423 10.811 10.409C10.811 9.98433 10.6723 9.64633 10.395 9.395C10.1263 9.14367 9.71467 9.018 9.16 9.018H7.301V11.8ZM7.301 15.869H9.277C9.83167 15.869 10.2607 15.739 10.564 15.479C10.876 15.219 11.032 14.855 11.032 14.387C11.032 13.919 10.8717 13.5507 10.551 13.282C10.2303 13.0047 9.797 12.866 9.251 12.866H7.301V15.869ZM13.9464 17V7.9H17.1314C17.8421 7.9 18.4314 8.02133 18.8994 8.264C19.3674 8.498 19.7141 8.823 19.9394 9.239C20.1734 9.64633 20.2904 10.11 20.2904 10.63C20.2904 11.124 20.1778 11.579 19.9524 11.995C19.7358 12.4023 19.3934 12.7273 18.9254 12.97C18.4574 13.2127 17.8594 13.334 17.1314 13.334H15.3244V17H13.9464ZM15.3244 12.203H17.0664C17.7164 12.203 18.1801 12.0643 18.4574 11.787C18.7434 11.501 18.8864 11.1153 18.8864 10.63C18.8864 10.1273 18.7434 9.73733 18.4574 9.46C18.1801 9.174 17.7164 9.031 17.0664 9.031H15.3244V12.203Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullets);
export default __webpack_public_path__ + "static/media/bullets.297c19ac6a5156156f28f573f0393e57.svg";
export { ForwardRef as ReactComponent };